// Utilitaires pour interpréter le texte libre d'horaires scrapé sur Paris.fr
// (ex: "Période scolaire : horaire d'ouverture grand public 07:00 à 08:30 11:30 à 18:00").
// On se contente d'extraire les créneaux "HH:MM à HH:MM", quel que soit le
// texte qui les entoure.

const CRENEAU_REGEX = /(\d{1,2})[:h](\d{2})\s*(?:à|-|–)\s*(\d{1,2})[:h](\d{2})/g;

export function heureVersMinutes(heureStr) {
  const [h, m] = heureStr.split(':').map(Number);
  return h * 60 + m;
}

export function minutesVersHeure(minutes) {
  const h = Math.floor(minutes / 60) % 24;
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function parseCreneaux(horaireText) {
  if (!horaireText) return [];
  const creneaux = [];
  let match;
  CRENEAU_REGEX.lastIndex = 0;
  while ((match = CRENEAU_REGEX.exec(horaireText)) !== null) {
    const [, h1, m1, h2, m2] = match;
    creneaux.push({
      debut: parseInt(h1, 10) * 60 + parseInt(m1, 10),
      fin: parseInt(h2, 10) * 60 + parseInt(m2, 10),
    });
  }
  return creneaux;
}

// true = ouvert à cette heure, false = fermé, null = horaires non compris (statut incertain)
export function estOuvertA(horaireText, heureMinutes) {
  if (!horaireText || horaireText.trim().toLowerCase() === 'fermé') return false;
  const creneaux = parseCreneaux(horaireText);
  if (creneaux.length === 0) return null;
  return creneaux.some(c => heureMinutes >= c.debut && heureMinutes < c.fin);
}

// Renvoie le créneau qui couvre l'heure donnée, ou null.
export function creneauCouvrant(horaireText, heureMinutes) {
  const creneaux = parseCreneaux(horaireText);
  return creneaux.find(c => heureMinutes >= c.debut && heureMinutes < c.fin) || null;
}

// Insère un séparateur visuel (" · ") entre deux plages horaires distinctes
// (ex: "07:00 à 08:30 11:30 à 18:00"), qui sinon se lisent comme un seul
// bloc de chiffres accolés sans coupure.
export function formaterHoraireAffichage(horaireText) {
  if (!horaireText) return horaireText;
  CRENEAU_REGEX.lastIndex = 0;
  const matches = [...horaireText.matchAll(CRENEAU_REGEX)];
  if (matches.length === 0) return horaireText;

  const premier = matches[0];
  const dernier = matches[matches.length - 1];
  const prefix = horaireText.slice(0, premier.index).trim();
  const suffix = horaireText.slice(dernier.index + dernier[0].length).trim();
  const creneauxText = matches
    .map(m => `${m[1].padStart(2, '0')}:${m[2]} à ${m[3].padStart(2, '0')}:${m[4]}`)
    .join(' · ');

  return [prefix, creneauxText, suffix].filter(Boolean).join(' ');
}
